import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { environment } from 'src/environments/environment';
import { ListFormat } from 'typescript';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-add-institution-dialog',
  templateUrl: './add-institution-dialog.component.html',
  styleUrls: ['./add-institution-dialog.component.scss']
})
export class AddInstitutionDialogComponent implements OnInit {

  collegeNameArr = ['college1', 'college2', 'college3'];
  trainingInstituteNameArr = ['institute1', 'institute2', 'institute3'];
  //temp : any;

  instituteType: String = 'COLLEGE';
  // institutes: string[] = ['College', 'Training Institute'];
  institutes: any[] = [{ value: 'College', id: 'COLLEGE' }, { value: 'Training Institute', id: 'TRAINING_INSTITUTE' }];
  shortNameStatus: boolean = false;
  collegeList = [];
  instituteList = [];
  // typeList = [];
  selectedCollege = null;
  institutionId: String = "";
  listData: any;
  temp: any;
  campData: any = [];
  compareShortName: any;
  shortNameList: any;
  visible: boolean;
  // name = ('', [Validators.required]);


  constructor(
    public dialogRef: MatDialogRef<AddInstitutionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private campaignService: CampaignService,
    private utilityService: UtilityService, private campaign: CampaignService,
    private clipboardService: ClipboardService,
    private snackBarService: MatSnackBar,
  ) { }

  ngOnInit() {
    this.getAllShortName();
    // console.log("Name", name);
    this.getCollegeList('COLLEGE');
    this.getCollegeList('TRAINING_INSTITUTE');
    //this.url.disable();
   // console.log("Data",this.data);
    // this.shortName.disable();
  }

  // ngAfterViewInit() {
  //   this.instituteType = this.child.instituteType;
  // }

  getAllShortName(){
    this.campaign.getAllShortName().subscribe(response => {
     // console.log("Response", (response as any));
      this.shortNameList = (response as any).data;
    })
  }
  
  getCollegeList(campaignType: String): void {
    this.campaign.getListData(campaignType)
      .subscribe(response => {
        this.listData = (response as any).data;
    //    console.log('list--->', this.listData);
        this.campData.push((response as any).data);

        if (campaignType == "COLLEGE")
          this.collegeList = (response as any).data;
    //    console.log("value of collegelist: ", this.collegeList);
        this.listData = (response as any).data;

        if (campaignType == "TRAINING_INSTITUTE")
          this.instituteList = (response as any).data;
    //    console.log("value of institutelist: ", this.instituteList);
      });
  }


  copyUrl() {

    console.log("hello url", this.url.value)
    this.clipboardService.copyFromContent(this.url.value);
    this.snackBarService.open('Copied to clipboard', '', { duration: 2000 });

  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  instituteTypeArr: String[] = ['College', 'Training Institute'];
  myControl = new FormControl();

  name = new FormControl('', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator,Validators.pattern('^[^ ]{1}([A-Za-z. ])+[A-Za-z. ]+$')]);
  shortName = new FormControl('', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator,Validators.pattern('^[^ ]{1}([A-Za-z0-9 ])+[A-Za-z0-9 ]+$')]);
  branchName = new FormControl('', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator, Validators.pattern('^[^ ]{1}([A-Za-z ])+[A-Za-z ]+$')]);
  // Validators.pattern('^[a-zA-Z \-\']+')
  city = new FormControl('', [Validators.required, Validators.minLength(3),Validators.pattern('^[^ ]{1}([A-Za-z0-9 ])+[A-Za-z0-9 ]+$'),this.noWhitespaceValidator]);
  address = new FormControl('', [Validators.required , Validators.pattern(/^[a-zA-Z0-9\s,'-/.]*$/), this.noWhitespaceValidator]);
  //url = new FormControl('', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]);
  url = new FormControl('');
  options: string[] = ['Thakur Engineering college', 'Global Institute of Engineering', 'DY Patil College of Engineering'];
  institute: string[] = ['Jspiders', 'ABC', 'GeeksForGeeks'];
  disableButton: boolean = false;

  getErrorMessageOfCollegeName() {
    return this.name.hasError('required') ? 'Select College Name' :
     this.name.hasError('whitespace') ? 'No White Space Allowed' : 
     this.name.hasError('pattern') ? 'Please Enter Valid Input':'';
  }

  getErrorMessageOfInstituteName() {
    return this.name.hasError('required') ? 'Select Institute Name' :
     this.name.hasError('whitespace') ? 'No White Space Allowed' : 
     this.name.hasError('pattern') ? 'Please Enter Valid Input':'';
  }

  getErrorMessageOfShortName() {
    return this.shortName.hasError('required') ? 'Enter Short Name' :
    this.shortName.hasError('whitespace') ? 'No White Space Allowed' : 
    this.shortName.hasError('minlength')?'Input must be at least 3 characters' :
    this.shortName.hasError('pattern') ? 'Please Enter Valid Input':
  
    '';

  }

  getErrorMessageOfBranchName() {
    return this.branchName.hasError('required') ? 'Enter Branch Name' : 
    this.branchName.hasError('whitespace') ? 'No White Space Allowed' : 
    this.branchName.hasError('minlength')?'Input must be at least 3 characters':
    this.branchName.hasError('pattern') ? 'Please Enter Valid Input' : 
   
    '';
  }

  getErrorMessageOfCity() {
    return this.city.hasError('required') ? 'Enter City' : 
    this.city.hasError('whitespace') ? 'Invalid city' :
    this.city.hasError('minlength')?'Input must be at least 3 characters':
    this.city.hasError('pattern') ? 'Please Enter Valid Input' : 
    
    '';
  }

  getErrorMessageOfAddress() {
    return this.address.hasError('required') ? 'Enter Address' :
    this.address.hasError('whitespace') ? 'No White Space Allowed' :
    this.address.hasError('pattern') ? 'Invalid Address' :
    '';
  }

  getErrorMessageOfURL() {
    return this.url.hasError('required') ? 'Enter Url' : this.url.hasError('pattern') ? 'Enter Validate Url' : '';
  }


  onCollegeSelect(event, id) {
    console.log(event);
    if (event.isUserInput) {
      this.selectedCollege = event.source.value;
      this.institutionId = id;
      //   this.ShortName.setValue(this.selectedCollege.institution.shortName);
    }
  }

  public noWhitespaceValidator(control: FormControl) {
  //  console.log('value', control.value);
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  // createShortName(event) {
  //   console.log(event);
  //   let tempShortName = this.name.value + "";
  //   tempShortName = tempShortName.trim().replace(/ /g, "-").replace(new RegExp(/([/.\\#?%&(){},:;])/g), "-")
  //     .replace(new RegExp(/([-]{2,})/g), "-").replace(new RegExp(/ /g), '');

  //   let i = 0;
  //   if (this.instituteType === 'COLLEGE') {
  //     this.collegeList.map(campaignObject => {
  //       if (campaignObject.shortName === tempShortName) {
  //         i++;
  //       }
  //     });
  //   } else {
  //     this.instituteList.map(campaignObject => {
  //       if (campaignObject.shortName === tempShortName) {
  //         i++;
  //       }
  //     });
  //   }
  //   console.log("Temp",tempShortName);
  //   if (i !== 0) {
  //     // tempShortName += i;
  //     tempShortName = tempShortName.substr(0, tempShortName.length - 1) + (Number(tempShortName.substr(tempShortName.length - 1)) + i);
  //   }
  //  // this.shortName.setValue(tempShortName);
  //   console.log(tempShortName);
  //   console.log('this.shortName.invalid', this.shortName.invalid);
  //   if (this.shortName.invalid !== true){
  //     this.url.setValue(environment.campaignUrl + tempShortName);
  //   }
  // }

  onTypeChange(event) {
    // console.log(event);
    // this.shortName.setValue(this.temp);
    if (event.value == 'TRAINING_INSTITUTE') {
      this.instituteType = 'TRAINING_INSTITUTE';
    } else {
      this.instituteType = 'COLLEGE';
    }
    // this.name.setValue('');
    // this.shortName.setValue('');
    // this.city.setValue('');
    // this.branchName.setValue('');
    // this.address.setValue('');
    // this.url.setValue('');
    this.name.reset();
    this.shortName.reset();
    this.city.reset();
    this.branchName.reset();
    this.address.reset();
    this.url.reset();
  }

  addInstitution() {
    this.shortName.setValue(this.temp);
    this.disableButton = true;
    var requestBody = {
      address: this.address.value,
      branchName: this.branchName.value,
      city: this.city.value,
      institutionName: this.name.value,
      institutionType: this.instituteType,
      shortName: this.shortName.value,
      url: this.url.value
    }

  //  console.log("Short Name", requestBody);

    this.campaignService.addCollegeAndInstitute(requestBody)
      .subscribe(response => {
        this.disableButton = false;
        this.dialogRef.close("Added");
        this.utilityService.openSnackBar("Institution Added Successfully.");
        // this.dialogRef.close("Added");
      }, (error) => {
   //     console.log("error: ", error);

        this.disableButton = false;
      })
  }

  // changeUrlByShortName(event) {
  //   console.log('short name-->' + this.shortName.value);

  //   let tempUrl = this.shortName.value + "";
  //   console.log('temp -->', tempUrl);

  //   tempUrl = tempUrl.trim().replace(/ +/g, '-').replace(new RegExp(/([/.\\#?%&(){},:;])/g), "-")
  //     .replace(new RegExp(/([-]{2,})/g), "-").replace(new RegExp(/ /g), '');
  //   let i = 0;
  //   if (this.instituteType == "COLLEGE") {
  //     this.collegeList.map(campaignObject => {
  //       if (campaignObject.shortName === tempUrl) {
  //         i++;
  //         // console.log(i);

  //       }
  //     });
  //   }
  //   console.log('before substring tempUrl', tempUrl);

  //   if (i != 0)
  //     tempUrl = tempUrl.substr(0, tempUrl.length - 1) + (Number(tempUrl.substr(tempUrl.length - 1)) + i);
  //  // this.temp = tempUrl;
  //  // this.shortName.setValue(tempUrl);
  //   this.temp = tempUrl;
  //   console.log('After',tempUrl);
  //   this.url.setValue(environment.campaignUrl + tempUrl);
  // }

  // changeShortName() {
  //   this.shortNameStatus = false;
  // //  console.log('short name list',this.campData);
  // //  this.campData = this.campData[0].push(this.campData[1][1]);
  // //  console.log("after pushing new array: ", this.campData);
   
  //  for(let k=0 ; k < this.campData.length ; k++) {
  //   for (let i = 0; i < this.campData[k].length; i++) {
  //     console.log(i);
  //     // console.log("data log after ---------> ",this.campData[k]);
      
  //     for (let j = 0; j < this.campData[k][i].institution.branches.length; j++) {
  //       // console.log("all shortNames" ,this.campData[k][i].institution.branches[j].shortName);
  //       this.compareShortName =  this.shortName.value
  //       this.compareShortName = this.replaceSpace(this.shortName.value);
  //       if (this.compareShortName === this.campData[k][i].institution.branches[j].shortName) {
  //         this.shortNameStatus = true;
  //         // console.log('input----------------->', this.ShortName.value);
  //         // console.log('comparte with ----------------->', this.listData[i].institution.branches[j].shortName);
  //         // console.log('shortNameStatus------------------>', this.shortNameStatus);
  //       }
  //       // console.log('shortNameStatus------------------>', this.shortNameStatus);
  
  //     }
  //   }
  //  }
  // }

  changeUrlByShortName(event) {
    if(this.shortName.value != '')
      this.visible = true;
    else
      this.visible = false;
    //console.log("Short Name:", this.shortName.value);
    let tempUrl = this.shortName.value + "";
    // console.log("tempUrl", tempUrl);
    tempUrl = tempUrl.trim().replace(/ +/g, '-').replace(new RegExp(/([/.\\#?%&(){},:;])/g), "-")
      .replace(new RegExp(/([-]{2,})/g), "-").replace(new RegExp(/ /g), '');

    //this.shortName.setValue(tempUrl);
    this.temp = tempUrl;
    if (this.shortName.invalid !== true) {
 //     this.url.setValue(environment.campaignUrl1 + tempUrl);
        this.url.setValue(environment.campaignUrl1 + 'register/' + tempUrl);
    }
  }

  changeShortName() {
    this.shortNameStatus = false;
    for (let i = 0; i < this.shortNameList.length; i++) {
      if (this.shortName.value === this.shortNameList[i]) {
        this.shortNameStatus = true;
        // console.log('input-->', this.shortName.value);
        // console.log('comparte with -->', this.dataList[i].shortName);
        // console.log('shortNameStatus-->', this.shortNameStatus);
      }
    }
  }

  replaceSpace(str : string) 
  {     
      let s : string = ""; 
      
      for (let i = 0; i < str.length; ++i) { 
          if (str[i] == ' ')  
              s += '-'; 
          else
              s += str[i];  
      } 
      return s;   
  } 

}
